import PropTypes from 'prop-types'
import ContractVehicleShape from 'components/supplier_show/prop_shapes/contract_vehicle'

export default PropTypes.shape({
  count: PropTypes.number,
  items: PropTypes.arrayOf(ContractVehicleShape)
})
